// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_dq-6";
export var emphasizeQuantity = "_dq-3";
export var flatBottomCorners = "_dq-5";
export var productImage = "_dq-0";
export var quantityContainer = "_dq-2";
export var tooltip = "_dq-1";
export var wrapAndEllipsesOverflow = "_dq-4";